import { render, staticRenderFns } from "./VoucherRequestDetails.vue?vue&type=template&id=2662c036"
import script from "./VoucherRequestDetails.vue?vue&type=script&lang=js"
export * from "./VoucherRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports